'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(Language2) {
  Language2["ENGLISH"] = "en";
  Language2["SWEDISH"] = "sv";
  Language2["FINNISH"] = "fi";
  Language2["GERMAN"] = "de";
  Language2["NORWEGIAN"] = "no";
  Language2["DUTCH"] = "nl";
  Language2["TURKISH"] = "tr";
  Language2["DANISH"] = "dn";
  Language2["BRITISH"] = "gb";
  Language2["AUSTRALIAN"] = "au";
  Language2["CANADIAN"] = "ca";
  Language2["NEW_ZEALAND"] = "nz";
  Language2["RUSSIAN"] = "ru";
  Language2["LATVIAN"] = "lv";
  Language2["SPANISH"] = "es";
  Language2["MACEDONIAN"] = "mk";
  Language2["HUNGARIAN"] = "hu";
  Language2["CANADIAN_FRENCH"] = "cf";
  Language2["JAPANESE"] = "ja";
  Language2["HINDI"] = "hi";
  Language2["THAI"] = "th";
  Language2["ARGENTINE_SPANISH"] = "ar";
  Language2["ROMANIAN"] = "ro";
  Language2["SOUTH_AFRICAN"] = "za";
  Language2["CHILEAN"] = "cl";
  Language2["MANDARIN"] = "zh";
  Language2["PERU"] = "pe";
  Language2["BRAZILIAN_PORTUGUESE"] = "bp";
  Language2["ESTONIAN"] = "ee";
  Language2["IRISH"] = "ei";
})(exports.Language || (exports.Language = {}));
